export const productsReducer = (state = {loading: true, resultproduct: null, products: null, product: null, total: 0 } , action) => {
    switch (action.type) {
        case 'PRODUCT_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                products: action.payload.products,
                total: action.payload.total
            }
        case 'PRODUCT_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                product: action.payload
            }
        case 'PRODUCT_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                products: [...state.products, action.payload.product],
                resultproduct: action.payload.message
            }
        case 'PRODUCT_EDIT_SUCCESS':

            return {
                ...state,
                loading:false,
                products: state.products?.map(product => {
                    if (product._id === action.payload.product._id) {
                        return action.payload.product
                    } else {
                        return product
                    }
                }),
                resultproduct: action.payload.message
            }
        case 'PRODUCT_REMOVE_SUCCESS':
            return {
                ...state,
                loading:false,
                products: state.products.filter(product => product._id !== action.payload.productDeleted),
                resultproduct: action.payload.message
            }
        case 'PRODUCT_ENABLEDISABLE_SUCCESS':
            return {
                ...state,
                loading:false,
                product: {...state.product, active: action.payload.stateproduct},
                resultproduct: action.payload.message
            }
        case 'PRODUCT_RESET_RESULT':
            return {...state,
                resultproduct: null
            }
        case 'PRODUCT_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PRODUCT_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

